import React from "react"
import OndeffModal from "./OndeffModal";

export default class ZipFinderNearme extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            zip: '',
            ondeffCode: 'priceAndAvailabilityForm'
        }

        this.code = this.props.code;
        this.env = this.props.env;

        //Quote request props
        this.proId = this.props.proid;
        this.startVisible = this.props.startVisible ? true : false;
        this.initialCommercailData = [{ key: "project_type", value: "509" }]
        this.childRef = React.createRef();
    }

    handleClick = () => {
        if (this.childRef.current) {
          this.childRef.current.triggerChangeShowModal(); // Trigger the child's method
        }
    };

    handleSubmit = event => {
        event.preventDefault();

        const zip = this.state.zip;

        if (!this.validateValue(zip)) {
            this.showError('Zip Code is required');
            return;
        }

        if (!this.validateNumber(zip)) {
            this.showError('The zip code must have 5 number');
            return;
        }

        if (this.env.site === 'dumpster') {
            if (this.code == 'junk-removal') {
                this.setState({ ...this.state, ondeffCode: 'junkRemovalQuoteRequest' });
            } else if (this.code == 'comercial-trash-service') {
                this.setState({ ...this.state, ondeffCode: 'commercialWasteQuoteRequest' });
            } else {
                this.setState({ ...this.state, ondeffCode: 'priceAndAvailabilityForm' });
            }
        } else {
            this.setState({ ...this.state, ondeffCode: 'demolitionQuoteRequest' });
        }
        this.handleClick()

    }

    handleInputChange = event => {
        const target = event.target
        const value = target.value
        const name = target.name

        this.setState({
            [name]: value,
        })
    }

    validateValue = value => {
        return value !== '' ? true : false;
    }

    validateNumber = value => {
        const regex = new RegExp('^\\d{5}$');
        return regex.test(value);
    }

    showError = text => {
        const input = document.getElementById(this.props.id);

        input.value = '';
        input.placeholder = text;
    }


    render() {
        return (
        <>
            <div className="zip-finder dumpster smallest">
                <div className="container-fluid">
                    <section className="row">
                        <div className={`header-image header-image-home col-12 ${this.props.backgroundClass}`}>
                            <div className="row justify-content-center align-items-center h-100">
                                <div className="col-md-12 col-lg-8 hero-title text-center">

                                    <h1>{this.props.title}</h1>
                                    <h3>{this.props.text}</h3>

                                    <form className="row justify-content-center" onSubmit={this.handleSubmit}>
                                        <div className="col-md-12 col-lg-8 col-lg-offset-2 search">
                                            <div className="input-group" id="searcher">

                                                <input
                                                    id={this.props.id}
                                                    className="form-control"
                                                    type="search"
                                                    name="zip"
                                                    value={this.state.zip}
                                                    placeholder="Enter Zip Code"
                                                    onChange={this.handleInputChange}
                                                    maxLength='5'
                                                />

                                                <button
                                                    type="submit"
                                                    id="getStarted"
                                                    className="btn btn-primary btn-sm">{this.props.button}</button>

                                            </div>
                                        </div>
                                    </form>

                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="row title">
                        <div className="col-12">
                            <h3 className="justify-content-center text-white">{this.props.bottomtext}</h3>
                        </div>
                    </section>
                </div>
            </div>
            <OndeffModal
                proid={this.proId}
                ondeffCode={this.state.ondeffCode}
                ref={this.childRef}
                initialFormData={this.state.ondeffCode === 'commercialWasteQuoteRequest' && this.initialCommercailData }
            />
        </>
        )
    }
}